import { render, staticRenderFns } from "./accordionComponent.vue?vue&type=template&id=4cbc5bc3&scoped=true&"
import script from "./accordionComponent.vue?vue&type=script&lang=js&"
export * from "./accordionComponent.vue?vue&type=script&lang=js&"
import style0 from "./accordionComponent.vue?vue&type=style&index=0&id=4cbc5bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbc5bc3",
  null
  
)

export default component.exports